import React, { useState } from "react";
import { Select, Button } from "antd";
import classes from "./WelcomingBanner.module.css";
import { useSelector } from "react-redux";
import Autocomplete from "react-google-autocomplete";
import { CaretDownOutlined } from "@ant-design/icons";
import { GOOGLE_MAP_API_KEY } from "configs/AppConfig";

const { Option } = Select;

const proximityValues = [
  { label: "Within 5 km", value: 5 },
  { label: "Within 10 km", value: 10 },
  { label: "Within 20 km", value: 20 },
  { label: "Within 50 km", value: 50 },
  { label: "Within 75 km", value: 75 },
];

const eventData = [
  { value: 1, label: "Wedding" },
  { value: 2, label: "Birth days" },
  { value: 3, label: "Party" },
  { value: 4, label: "Anniversary" },
  { value: 5, label: "Baptism" },
  { value: 6, label: "Small Party" },
  { value: 7, label: "Birth dayss" },
  { value: 8, label: "Partys" },
  { value: 9, label: "Anniversarys" },
  { value: 10, label: "Baptisms" },
  { value: 11, label: "Small Partys" },
];

const ratingData = [
  { value: 1, label: "4 Star & above" },
  { value: 2, label: "3 Star & above" },
  { value: 3, label: "2 Star & above" },
  { value: 4, label: "1 Star & above" },
];

function DiscoverModal({
  proximityValues,
  categoryData,
  filterData,
  handleClick,
  filterDataChange,
  locationFinder,
  vendorList,
  eventTypes,
}) {
  const placeholderStyle = {
    color: "black",
    fontSize: "14px",
    fontFamily: "Roboto",
    fontWeight: 400,
    paddingLeft: "8px",
  };

  const location = useSelector((state) => state.filter);
  const user = useSelector((state) => state.user.user);
  console.log("location values are", location, user);

  // const bannerSrc = !isLoading && !isError && data.data[0].image;

  const customArrow = (
    <img
      src="/img/dropdown-arrow.svg"
      style={{ width: "24px", height: "24px" }}
    /> // Customize the arrow color as needed
  );

  return (
    <div className={classes.modalOuterDiv}>
      <h2>Discover Dreamy Venues & More !</h2>
      {/* <Select
        suffixIcon={customArrow}
        placeholder={<span style={placeholderStyle}>Location</span>}
        style={{ width: "100%", height: "50px", marginBottom: "20px" }}
      >
      </Select> */}
      <div className="autocomplete-div">
        <Autocomplete
          className="banner-location"
          onPlaceSelected={locationFinder}
          // types={["(cities)"]} // Customize types as needed
          style={{ width: "100%", boxSizing: "border-box" }}
          // onChange={(e) => setSelectedAddress(e.target.value)}
          placeholder={"Enter a Location"}
          apiKey={GOOGLE_MAP_API_KEY}
          options={{
            // Try searching all place types, not just addresses
            types: ["establishment", "geocode"], // Use 'establishment' to include businesses like "Lulu"
            fields: [
              "name",
              "formatted_address",
              "geometry",
              "address_components",
              "place_id",
              "vicinity",
            ], // 👈 ADD THIS
            componentRestrictions: { country: "in" }, // restrict to India or your country
          }}
        />
        <CaretDownOutlined className={"dropdown-arrow"} />
      </div>
      {/* <Select
        onChange={(value) => filterDataChange("vendorId", value)}
        suffixIcon={customArrow}
        placeholder={<span style={placeholderStyle}>Search for Vendors</span>}
        style={{ width: "100%", height: "50px" }}
      >
        {vendorList?.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select> */}
      <Select
        onChange={(value) => filterDataChange("eventType", value)}
        suffixIcon={customArrow}
        placeholder={<span style={placeholderStyle}>Event type</span>}
        style={{ width: "100%", height: "50px" }}
        className="event-select"
      >
        {eventTypes?.map((option) => (
          <Option key={option?.slug} value={option?.slug}>
            {option?.name}
          </Option>
        ))}
      </Select>
      {/* <Select
        onChange={(value) => filterDataChange("ratingId", value)}
        suffixIcon={customArrow}
        placeholder={<span style={placeholderStyle}>Rating</span>}
        style={{ width: "100%", height: "50px", marginBottom: "13px" }}
      >
        {ratingData.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select> */}
      <Button className={classes.filterButton} onClick={handleClick}>
        Search
      </Button>
    </div>
  );
}

export default DiscoverModal;
